'use strict';

var tslib = require('tslib');
var React = require('react');
var cn = require('classnames');
var styled = require('styled-components');
var lightThemeColors = require('@prisjakt/design-tokens/light-theme-colors');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cn__default = /*#__PURE__*/_interopDefaultLegacy(cn);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

exports.Behavior = void 0;
(function (Behavior) {
    Behavior["Multiline"] = "multiline";
    Behavior["Oneline"] = "oneline";
    Behavior["OnelineEllipsis"] = "oneline-ellipsis";
    Behavior["TwolineEllipsis"] = "twoline-ellipsis";
})(exports.Behavior || (exports.Behavior = {}));
exports.FontScale = void 0;
(function (FontScale) {
    FontScale["XS"] = "xs";
    FontScale["S"] = "s";
    FontScale["M"] = "m";
    FontScale["L"] = "l";
    FontScale["XL"] = "xl";
    FontScale["XXL"] = "xxl";
})(exports.FontScale || (exports.FontScale = {}));
exports.FontWeight = void 0;
(function (FontWeight) {
    FontWeight[FontWeight["NORMAL"] = 400] = "NORMAL";
    FontWeight[FontWeight["HEAVIER"] = 600] = "HEAVIER";
    FontWeight[FontWeight["HEAVIEST"] = 700] = "HEAVIEST";
})(exports.FontWeight || (exports.FontWeight = {}));
exports.FontColor = void 0;
(function (FontColor) {
    FontColor["LIGHT"] = "light";
    FontColor["DARK"] = "dark";
    FontColor["PRIMARY"] = "primary";
    FontColor["POSITIVE"] = "positive";
    FontColor["NEGATIVE"] = "negative";
})(exports.FontColor || (exports.FontColor = {}));
exports.FontEmphasis = void 0;
(function (FontEmphasis) {
    FontEmphasis[FontEmphasis["HIGH"] = 1] = "HIGH";
    FontEmphasis[FontEmphasis["MEDIUM"] = 0.72] = "MEDIUM";
    FontEmphasis[FontEmphasis["LOW"] = 0.48] = "LOW";
})(exports.FontEmphasis || (exports.FontEmphasis = {}));

var mediumUp = 'screen and (min-width: 39.9376em)';
var sharedScales = {
    xs: {
        fontSize: '0.75rem',
        lineHeight: '1.66667',
        letterSpacing: '0.02em',
    },
    s: {
        fontSize: '0.875rem',
        lineHeight: '1.42857',
        letterSpacing: '0.01em',
    },
    m: {
        fontSize: '1rem',
        lineHeight: '1.5',
        letterSpacing: '0',
    },
};
var desktopScales = {
    l: {
        fontSize: '1.25rem',
        lineHeight: '1.4',
        letterSpacing: '0',
    },
    xl: {
        fontSize: '1.5rem',
        lineHeight: '1.3333',
        letterSpacing: '-0.01em',
    },
    xxl: {
        fontSize: '2rem',
        lineHeight: '1.25',
        letterSpacing: '-0.02em',
    },
};
var mobileScales = {
    l: {
        fontSize: '1.125rem',
        lineHeight: '1.3333',
        letterSpacing: '0',
    },
    xl: {
        fontSize: '1.25rem',
        lineHeight: '1.4',
        letterSpacing: '0',
    },
    xxl: {
        fontSize: '1.5rem',
        lineHeight: '1.3333',
        letterSpacing: '-0.01em',
    },
};
var scales = {
    desktop: tslib.__assign(tslib.__assign({}, sharedScales), desktopScales),
    mobile: tslib.__assign(tslib.__assign({}, sharedScales), mobileScales),
};
var colors = {
    light: lightThemeColors.staticBase0,
    dark: lightThemeColors.staticBase800,
    primary: lightThemeColors.staticMaybeBlue700,
    positive: lightThemeColors.staticPositive700,
    negative: lightThemeColors.staticRedio700,
    interactiveHover: lightThemeColors.staticMaybeBlue500,
};
var oneline = styled.css(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  white-space: nowrap;\n"], ["\n  white-space: nowrap;\n"])));
var onelineEllipsis = styled.css(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n"], ["\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n"])));
var twolineEllipsis = styled.css(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n"], ["\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n"])));
var Text$1 = styled__default["default"].span.withConfig({ displayName: "Text", componentId: "-12qn20f" })(function (p) {
    var _a;
    return styled.css(templateObject_4 || (templateObject_4 = tslib.__makeTemplateObject(["\n    flex: ", ";\n    user-select: ", ";\n    font-size: ", ";\n    letter-spacing: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    color: ", ";\n    opacity: ", ";\n\n    &[type='button'],\n    &[href] {\n      color: ", ";\n      text-decoration: none;\n      transition: color 150ms ease;\n\n      &:hover {\n        color: ", ";\n      }\n    }\n\n    @media ", " {\n      font-size: ", ";\n      letter-spacing: ", ";\n      line-height: ", ";\n    }\n\n    ", ";\n    ", ";\n    ", ";\n  "], ["\n    flex: ", ";\n    user-select: ", ";\n    font-size: ", ";\n    letter-spacing: ", ";\n    line-height: ", ";\n    font-weight: ", ";\n    color: ", ";\n    opacity: ", ";\n\n    &[type='button'],\n    &[href] {\n      color: ", ";\n      text-decoration: none;\n      transition: color 150ms ease;\n\n      &:hover {\n        color: ", ";\n      }\n    }\n\n    @media ", " {\n      font-size: ", ";\n      letter-spacing: ", ";\n      line-height: ", ";\n    }\n\n    ", ";\n    ", ";\n    ", ";\n  "])), p.$flex === true ? '1 1 auto' : (_a = p.$flex) !== null && _a !== void 0 ? _a : '0', p.$selectable ? 'auto' : 'none', scales.mobile[p.$scale].fontSize, scales.mobile[p.$scale].letterSpacing, scales.mobile[p.$scale].lineHeight, p.$weight, p.$color ? colors[p.$color] : 'inherit', p.$emphasis, colors.primary, colors.interactiveHover, mediumUp, scales.desktop[p.$scale].fontSize, scales.desktop[p.$scale].letterSpacing, scales.desktop[p.$scale].lineHeight, p.$behavior === exports.Behavior.Oneline && oneline, p.$behavior === exports.Behavior.OnelineEllipsis && onelineEllipsis, p.$behavior === exports.Behavior.TwolineEllipsis && twolineEllipsis);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

/**
 * Component that renders text with different styles.
 */
var Text = function (props) {
    var _a = props.behavior, behavior = _a === void 0 ? exports.Behavior.Multiline : _a, _b = props.selectable, selectable = _b === void 0 ? true : _b, children = props.children, _c = props.container, container = _c === void 0 ? 'span' : _c, containerProps = props.containerProps, className = props.className, variant = props.variant, style = props.style, _d = props.scale, scale = _d === void 0 ? exports.FontScale.M : _d, _e = props.weight, weight = _e === void 0 ? exports.FontWeight.NORMAL : _e, color = props.color, _f = props.emphasis, emphasis = _f === void 0 ? exports.FontEmphasis.HIGH : _f, _g = props.flex, flex = _g === void 0 ? true : _g;
    return (React__default["default"].createElement(Text$1, tslib.__assign({ className: cn__default["default"](variant, className), style: style, 
        // `as` type is current broken. Waiting for fix (https://github.com/DefinitelyTyped/DefinitelyTyped/issues/50404)
        as: container, title: [exports.Behavior.OnelineEllipsis, exports.Behavior.TwolineEllipsis].includes(behavior)
            ? children === null || children === void 0 ? void 0 : children.toString()
            : '' }, containerProps, { "$behavior": behavior, "$selectable": selectable, "$scale": scale, "$weight": weight, "$color": color, "$emphasis": emphasis, "$flex": flex }), children));
};

exports.Text = Text;
//# sourceMappingURL=index-6f152094.js.map
